import {GetRefundProfessionals} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRefundGetProfessionals} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRefundProfessionals = (): GetRefundProfessionals =>
	new RemoteRefundGetProfessionals(
		makeBFFApiUrl(RefundFlowEndPoints.professionals),
		makeAuthorizeHttpClientDecorator(),
	);
